var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoanRequestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.339 24.678C19.1536 24.678 24.678 19.1536 24.678 12.339C24.678 5.52436 19.1536 0 12.339 0C5.52436 0 0 5.52436 0 12.339C0 19.1536 5.52436 24.678 12.339 24.678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9336 7.30599V6.42285M12.9336 10.5441V9.66096",
    stroke: "#FF468A",
    strokeWidth: 0.588756,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1353 9.37482C12.2386 9.54575 12.4263 9.66068 12.6396 9.66068H13.2283C13.5521 9.66068 13.8171 9.39574 13.8171 9.07192C13.8171 8.74812 13.5521 8.48318 13.2283 8.48318H12.6395C12.3158 8.48318 12.0508 8.21824 12.0508 7.89442C12.0508 7.5706 12.3157 7.30566 12.6395 7.30566H13.2283C13.4415 7.30566 13.6292 7.42059 13.7326 7.59152",
    stroke: "#FF468A",
    strokeWidth: 0.588756,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4331 6.41265C9.96868 6.97311 9.68945 7.69264 9.68945 8.47742C9.68945 10.2658 11.1392 11.7156 12.9276 11.7156C14.716 11.7156 16.1658 10.2658 16.1658 8.47742C16.1658 6.68905 14.716 5.23926 12.9276 5.23926C12.1428 5.23926 11.4233 5.51849 10.8628 5.98294",
    stroke: "#FF468A",
    strokeWidth: 0.588756,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27997 13.8977V17.8611H5.07422V13.8977H8.10714C8.64667 13.3581 9.26157 13.2256 9.69195 13.2256H10.4143C11.2443 13.2256 11.5459 13.74 12.3932 13.74H13.8571C14.3119 13.74 14.7128 14.0417 14.7509 14.4948M14.7509 14.4948C14.7889 14.9478 14.4508 15.3885 13.9961 15.3885H10.9632M14.7509 14.4948L18.0293 13.0187C18.6383 12.7444 19.4088 13.0957 19.5831 13.6766C19.6702 13.9668 19.4764 14.2122 19.2136 14.3633L12.8351 18.0283H12.008L8.65857 17.3097H7.27997",
    stroke: "#FF468A",
    strokeWidth: 0.588756,
    strokeMiterlimit: 22.9256
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.678,
    height: 24.677,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanRequestIcon);
export default __webpack_public_path__ + "static/media/LoanRequestIcon.86a3f499a5f5d3f9afe0337de6087e93.svg";
export { ForwardRef as ReactComponent };